import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import AmericanEnglish from "./translations/AmericanEnglish.json";
import Japanese from "./translations/Japanese.json";

const resources = {
  en: {
    translation: AmericanEnglish,
  },
  jp: {
    translation: Japanese,
  },
};

const localStorageLanguageKey = "lang";

const languages = ["en", "jp"] as const;
export type Language = typeof languages[number];

const fallbackLng: Language = "en";

export const detectLanguage = () => {
  const storedLanguage = globalThis?.localStorage?.getItem(localStorageLanguageKey);

  if (typeof storedLanguage === "string" && (languages as readonly string[]).includes(storedLanguage)) {
    return storedLanguage;
  }

  return fallbackLng;
};

export const setStoredLanguage = (language: Language) => {
  globalThis?.localStorage?.setItem(localStorageLanguageKey, language);
};

i18n.use(initReactI18next).init({
  resources,
  lng: detectLanguage(),
  fallbackLng,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
